import React from 'react'; // eslint-disable-line

class DropMenu extends React.Component {
    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
    }

    logout() {
        if (this.props.logout) {
            this.props.logout();
        }
    }

    render() {
        const {
            Visible,
        } = this.props;

        return (
            <div className={`drop-menu ${Visible ? 'dialog-show' : 'dialog-hide'}`}>
                {/* eslint-disable-next-line  */}
                <div className="logout" onClick={this.logout}>
                    {/* eslint-disable-next-line react/button-has-type */}
                    <button>Logout</button>
                </div>
            </div>
        );
    }
}

export default DropMenu;
